import { HttpBackend, HttpClient } from '@angular/common/http';
import { ApplicationRef, Injectable } from '@angular/core';
import { SwUpdate, UpdateAvailableEvent } from '@angular/service-worker';
import { NGXLogger } from 'ngx-logger';
import { Subject, interval } from 'rxjs';
import { isNullOrEmpty } from '../public-api';

@Injectable({
  providedIn: 'root',
})
export class AppUpdateDetectionService {
  private _versionSubject = new Subject<UpdateAvailableEvent>();
  versionSubject = this._versionSubject.asObservable();
  versionTimestamp?: number;

  constructor(
    private appRef: ApplicationRef,
    private updates: SwUpdate,
    private httpBackend: HttpBackend,
    private logger: NGXLogger
  ) {
    if (this.isEnabled) {
      this.logger.debug(
        'AppUpdateDetectionService - constructor: Subscribe interval SwUpdate checkForUpdate'
      );
      interval(60 * 1000).subscribe(
        () => {
          updates.checkForUpdate().then(() => {
            this.logger.debug(
              'AppUpdateDetectionService - SwUpdate: checkForUpdate'
            );
            new HttpClient(this.httpBackend)
              .get('ngsw.json?timestamp=' + new Date().getTime())
              .subscribe(
                (result: any) => {
                  this.logger.debug(
                    'AppUpdateDetectionService - timer: check version',
                    { browser: this.versionTimestamp, server: result.timestamp }
                  );
                  let versionTS = this.versionTimestamp?.toString();
                  let timestampString = result.timestamp.toString();
                  if (
                    !isNullOrEmpty(versionTS) &&
                    timestampString != versionTS
                  ) {
                    this.logger.info(
                      'AppUpdateDetectionService - constructor - check timer: New version detected.'
                    );
                    const updateAvailableEvent = {} as UpdateAvailableEvent;
                    this._versionSubject.next(updateAvailableEvent);
                  }
                  this.versionTimestamp = result.timestamp;
                },
                (err) => {
                  this.logger.error('Failed to fetch version info.', err);
                }
              );
          });
        },
        (err) => {
          this.logger.error('Failed to check version updates.', err);
        }
      );
    }
  }

  get isEnabled(): boolean {
    return this.updates.isEnabled;
  }

  checkForUpdates(): void {
    this.updates.available.subscribe((event) => {
      this.logger.info(
        'AppUpdateDetectionService SwUpdate - available: New version detected.',
        event
      );
      this.versionTimestamp = (event.available.appData as any)?.timestamp;
      this._versionSubject.next(event);
    });
  }

  loadNewAppVersion(): void {
    this.updates.activateUpdate().then(() => {
      window.location.reload();
    });
  }
}
